var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShieldChek(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 10 12",
    width: 10,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h12v12h-12z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5 6 .75.75 1.5-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.75 5.3835c0 2.21277154 1.37359921 4.19307661 3.44614 4.968275l.015035.005625c.50875998.1902941 1.06918572.1901165 1.577825-.0005l.01218-.004565c2.07440232-.77740306 3.44882-2.76023209 3.44882-4.97552v-1.8617c0-.43743824-.28431551-.82410716-.70186-.954525l-3.25-1.015115c-.19413216-.06063505-.40213784-.06063505-.59627 0l-3.25 1.015085c-.41754845.13041427-.70187.51708405-.70187.954525z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldChek);
export default __webpack_public_path__ + "static/media/shield-chek.7b9300cbb997af96126ac6db5d005656.svg";
export { ForwardRef as ReactComponent };